import MaterialIcon from '@material/react-material-icon';
import { Button } from '@upmc/ims.component-library';

import { Link } from 'react-router-dom';

export default class CmsObjectDTRow {
	//convert  baseCMSObject to compatible model for use with DataTable component
	constructor(BaseCMSObject, deleteHandler) {
		this.ActionCells = [];
		this.Cells = this.ConvertObjectToCells(BaseCMSObject);
		this.Key = BaseCMSObject.ID.toString();
		this.DeleteHandler = deleteHandler;
	}

	static Headers = [
		{ Value: 'Actions', props: { sort: null, onSortChange: null } },
		{ Value: 'ID', props: { sort: null, onSortChange: null } },
		{ Value: 'Description', props: { sort: null, onSortChange: null } },
		{ Value: 'Status', props: { sort: null, onSortChange: null } },
		{ Value: 'Type', props: { sort: null, onSortChange: null } },
		{ Value: 'StartDate', props: { sort: null, onSortChange: null } },
		{ Value: 'EndDate', props: { sort: null, onSortChange: null } },
	];

	ConvertObjectToCells = BaseCMSObject => {
		return {
			Actions: {
				Value: (
					<>
						<Link
							to={`/CMSManagement/${BaseCMSObject.ID}`}
							id={`Link_CMSObject_Detail_${BaseCMSObject.ID}`}
						>
							<Button
								variant='outlined'
								startIcon={<MaterialIcon icon='edit' />}
							>
								Edit
							</Button>
						</Link>
						<br />

						<Button
							startIcon={<MaterialIcon icon='delete' />}
							onClick={() => this.DeleteHandler(BaseCMSObject)}
						>
							Delete
						</Button>
					</>
				),
				Validation: {
					Key: 'true',
					Value: null,
					memberToValidateKey: null,
				},
			},
			ID: {
				Value: BaseCMSObject.ID.toString(),
				Validation: {
					Key: 'true',
					Value: null,
					memberToValidateKey: null,
				},
			},
			StartDate: {
				Value: BaseCMSObject.StartDate,
				Validation: {
					Key: 'true',
					Value: null,
					memberToValidateKey: null,
				},
			},
			EndDate: {
				Value: BaseCMSObject.EndDate,
				Validation: {
					Key: 'true',
					Value: null,
					memberToValidateKey: null,
				},
			},
			Type: {
				Value: BaseCMSObject.ObjectType
					? BaseCMSObject.ObjectType.Name
					: '',
				Validation: {
					Key: 'true',
					Value: null,
					memberToValidateKey: null,
				},
			},
			Description: {
				Value: BaseCMSObject.Description,
				Validation: {
					Key: 'true',
					Value: null,
					memberToValidateKey: null,
				},
			},
			Status: {
				Value: BaseCMSObject.Status,
				Validation: {
					Key: 'true',
					Value: null,
					memberToValidateKey: null,
				},
			},
		};
	};

	static ConvertArray(BaseCMSObjectArr, deleteHandler) {
		return BaseCMSObjectArr.map(obj => {
			return new CmsObjectDTRow(obj, deleteHandler);
		});
	}
}
